import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RendererProvider } from '@atlassiansox/bxp-content-framework';
import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { useAnalytics, FooterContextProvider, AnalyticsAttributesProvider } from '../../components';
import { renderViewModels, renderViewModel } from '../../render-view-model';
import { isBackgroundFieldArray, isBackgroundFieldValue } from '../../styles';
import { generateFieldsStyles, cssColorsFromBackgroundField } from '../../styles';
export default function Page({ model }) {
    const { sendPageEvent } = useAnalytics();
    const { entryTitle, title, route, variant, header, sections = [], footer, background, pageBackground, cookieBanner } = model.content;
    useEffect(() => {
        sendPageEvent('', {
            path: route.content.path,
            title,
            pageVariant: variant
        });
    }, [route.content.path, sendPageEvent]);
    return (_jsxs(RendererProvider, Object.assign({ renderer: renderViewModel }, { children: [_jsx(GlobalStyle, { backgroundField: isBackgroundFieldValue(background) ? background : undefined, pageBackground: isBackgroundFieldArray(pageBackground) ? pageBackground : undefined }, void 0), _jsx(FooterContextProvider, { children: _jsxs(AnalyticsAttributesProvider, Object.assign({ value: { labelEnglish: entryTitle } }, { children: [header && renderViewModel(header), _jsx("main", Object.assign({ id: "skip-target", tabIndex: -1 }, { children: renderViewModels(sections) }), void 0), footer && renderViewModel(footer), cookieBanner && renderViewModel(cookieBanner)] }), void 0) }, void 0)] }), void 0));
}
export const GlobalStyle = createGlobalStyle `
  body {
    ${({ backgroundField }) => cssColorsFromBackgroundField(backgroundField)}
    ${({ pageBackground }) => pageBackground && generateFieldsStyles(pageBackground)}
  }
`;
//# sourceMappingURL=Page.js.map